import React from 'react';
import {useNavigate} from 'react-router';
import {Button, Chip, IconButton, Stack, Typography} from '@mui/material';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

/**
 * Lightweight header for Disclosure Officer review pages.
 * Mirrors the default layout (back button + title + optional approved chip).
 */
const DisclosureHeader = ({
                              title,
                              status,
                              backPath = '/disclosures',
                              saving = false,
                              onApprove,
                              onReject,
                          }) => {
    const navigate = useNavigate();
    const isApproved = status === 'approved';
    const isAwaitingReview = status === 'Awaiting Review';

    return (
        <Stack
            direction="row"
            alignItems="flex-start"
            boxSizing="border-box"
            p={1}
            pr={2}
            bgcolor="white"
            spacing={2}
            justifyContent="space-between"
        >
            <Stack direction="row" alignItems="flex-start" spacing={1} flex={1} minWidth={0}>
                <IconButton onClick={() => navigate(backPath || -1)} sx={{flexShrink: 0, mt: 0.25}}>
                    <ArrowBackOutlinedIcon/>
                </IconButton>
                <Typography
                    variant="h6"
                    component="h1"
                    sx={{
                        mr: 2,
                        flex: 1,
                        minWidth: 0,
                        whiteSpace: 'normal',
                        overflowWrap: 'break-word',
                        textWrap: 'pretty',
                    }}
                >
                    {title || 'Disclosure'}
                </Typography>
            </Stack>

            <Stack direction="row" spacing={1} flexShrink={0} sx={{pt: 0.25}}>
                {isApproved && (
                    <Chip
                        label="Approved"
                        color="success"
                        size="small"
                        icon={<CheckCircleOutlineIcon/>}
                    />
                )}
                {isAwaitingReview && (
                    <>
                        <Button
                            variant="contained"
                            color="success"
                            disabled={saving}
                            onClick={onApprove}
                        >
                            Approve
                        </Button>
                        <Button
                            variant="outlined"
                            color="error"
                            disabled={saving}
                            onClick={onReject}
                        >
                            Not approved
                        </Button>
                    </>
                )}
            </Stack>
        </Stack>
    );
};

export default DisclosureHeader;
